import { mapMutations, mapState } from "vuex";

export function createMixin() {
    return {
        data() {
            return {
                rightIsNotScrollable: true,
                leftIsNotScrollable: true,
                elementIsNotScrollable: true,
            }
        },
        methods: {
            doesRightIsNotScrollable() {
                return this.$refs[this.reference].scrollLeft === this.$refs[this.reference].scrollLeftMax
                ||  this.$refs[this.reference].scrollLeft === (this.$refs[this.reference].scrollWidth - this.$refs[this.reference].clientWidth);
            },
            doesLeftIsNotScrollable() {
                return this.$refs[this.reference].scrollLeft === 0;
            },
            doesElementIsNotScrollable() {
                return this.leftIsNotScrollable && this.rightIsNotScrollable;
            },
            checkForInactivesButtons() {
                if(!this.$refs[this.reference]) {
                    return;
                }

                this.rightIsNotScrollable = this.doesRightIsNotScrollable();
                this.leftIsNotScrollable = this.doesLeftIsNotScrollable();
                this.elementIsNotScrollable = this.doesElementIsNotScrollable();
            },
            scroll(modifier) {
                this.$refs[this.reference].scrollBy({ left: this.scrollStep * modifier, behavior: 'smooth' });
            },
            selectedItemToCenter() {
                if(!this.$refs[this.reference]) {
                    return;
                }

                let selectedItem = -1;
    
                for (const [index, element] of Object.entries(this.$refs[this.reference].children)) {
                    if(element.classList.contains("active")) {
                        break;
                    } else {
                        selectedItem++;
                    }
                }
    
                let scrollTo =  (this.scrollStep * selectedItem) - (this.$refs[this.reference].clientWidth / 2) + this.scrollStep / 2;
    
                this.$refs[this.reference].scrollTo({ left: scrollTo, behavior: 'smooth' });
            },
        },
        mounted() {
            if(!this.$refs[this.reference]) {
                return;
            }
            
            this.checkForInactivesButtons();
            this.selectedItemToCenter();

            this.$refs[this.reference].addEventListener("scroll", this.checkForInactivesButtons);
            window.addEventListener("resize", this.checkForInactivesButtons);
            window.addEventListener("resize", this.selectedItemToCenter);
        },
        beforeDestroy() {
            if(!this.$refs[this.reference]) {
                return;
            }
            
            this.$refs[this.reference].removeEventListener("scroll", this.checkForInactivesButtons)
            window.removeEventListener("resize", this.checkForInactivesButtons);
            window.removeEventListener("resize", this.selectedItemToCenter);
        },
    }
}
